export function validateCodiceFiscale(cf) {
  if (!cf || !cf.trim()) return { valid: true, error: "" };
  cf = cf.toUpperCase().trim();
  if (cf.length === 11 && /^\d{11}$/.test(cf)) return { valid: true, error: "" };
  if (cf.length === 13 && /^[A-Z0-9]{13}$/.test(cf)) return { valid: true, error: "" };
  if (cf.length === 16 && /^[A-Z0-9]{16}$/.test(cf)) return { valid: true, error: "" };
  return { valid: false, error: "Formati accettati: 11 cifre, 13 alfanumerici, o 16 alfanumerici" };
}

export function validatePartitaIVA(piva) {
  if (!piva || !piva.trim()) return { valid: true, error: "" };
  piva = piva.trim().toUpperCase();
  if (piva.startsWith("IT")) piva = piva.slice(2);
  if (piva.length === 11 && /^\d{11}$/.test(piva)) return { valid: true, error: "" };
  if (piva.length === 13 && /^[A-Z0-9]{13}$/.test(piva)) return { valid: true, error: "" };
  return { valid: false, error: "Formati accettati: 11 cifre o 13 alfanumerici" };
}
